import * as React from "react";
const SvgBBIConsRelationDirection = (props) => (
  <svg
    width="23"
    height="6"
    viewBox="0 0 23 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.897339 3H19.5" stroke="black" stroke-width="2" />
    <path d="M23 3L17.75 5.59808V0.401924L23 3Z" fill="black" />
  </svg>
);
export default SvgBBIConsRelationDirection;
